module.exports = __webpack_public_path__ + "assets/img/donate-pop-bg.8f06c298.png";